import { render } from "./RiskFactorCountView.html?vue&type=template&id=55f08ed4"
import script from "./RiskFactorCountView.js?vue&type=script&lang=js"
export * from "./RiskFactorCountView.js?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__